import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.min.js"

// To handle the font loading issue caused by using pathPrefix & assetPrefix we are maintaing 2 diff files, 
// global-dev, global-prod and load them as per env variable value
import "./static/css/global.css"
import "./hs-shared/static/css/fonts.css";

import React from 'react';
import Layout from "./src/components/Layout";

export const wrapRootElement = ({ element }) => {
    return <Layout>{element}</Layout>
};
